import React from "react";

const UserLocationIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36.206"
      height="40.069"
      viewBox="0 0 36.206 40.069"
    >
      <g
        id="Group_1391"
        data-name="Group 1391"
        transform="translate(-775.477 -180.783)"
      >
        <path
          id="Subtraction_1"
          data-name="Subtraction 1"
          d="M18725.2-14985.562H18704a16.791,16.791,0,0,1,16.771-16.771h1.52a16.66,16.66,0,0,1,9.605,3.029,10.45,10.45,0,0,0-7.371,10.025,10.478,10.478,0,0,0,.676,3.716Zm-3.674-17.6a8.432,8.432,0,0,1-8.422-8.421,8.429,8.429,0,0,1,8.422-8.416,8.428,8.428,0,0,1,8.42,8.416A8.43,8.43,0,0,1,18721.529-15003.161Z"
          transform="translate(-17928.523 15200.781)"
          fill={fill ? fill : "#a07eff"}
        />
        <path
          id="db77"
          d="M253.311,186.57a5.181,5.181,0,0,0-5.181,5.181,7.237,7.237,0,0,0,.96,3.262l4.222,6.908,4.222-6.908a7.238,7.238,0,0,0,.96-3.262A5.181,5.181,0,0,0,253.311,186.57Zm0,2.687a2.495,2.495,0,1,1-2.495,2.495A2.495,2.495,0,0,1,253.311,189.257Z"
          transform="translate(553.189 18.93)"
          fill={fill ? fill : "#a07eff"}
        />
      </g>
    </svg>
  );
};

export default UserLocationIcon;
